// extracted by mini-css-extract-plugin
export default {"toolsBody":"Reviews_toolsBody__UOQjS","heading":"Reviews_heading__K2+tq","section":"Reviews_section__nNLI9"};